/**
 * Internationalization formatters
 */
const LOCALE = "es-ES"; // Spanish locale for formatting
/**
 * Formats a numeric value using Spanish locale formatting
 */
export const formatNumber = (value, fractionDigits = 0) => {
    return new Intl.NumberFormat(LOCALE, {
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
        useGrouping: true,
    }).format(parseFloat(String(value)) || 0);
};
/**
 * Formats a numeric value as a percentage
 */
export const formatPercentage = (value, fractionDigits = 2) => {
    const rawValue = String(value).trim();
    const num = parseFloat(rawValue.replace(',', '.')) || 0;
    const normalized = rawValue.includes("%") ? num / 100 : num;
    return new Intl.NumberFormat(LOCALE, {
        style: "percent",
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
        useGrouping: true,
    }).format(normalized);
};
/**
 * Formats a numeric value as a percentage when the input already comes in 0-100 scale
 */
export const formatWholePercentage = (value, fractionDigits = 2) => {
    const rawValue = String(value).trim();
    const num = parseFloat(rawValue.replace(',', '.')) || 0;
    const normalized = rawValue.includes("%") ? num / 100 : num / 100;
    return new Intl.NumberFormat(LOCALE, {
        style: "percent",
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
        useGrouping: true,
    }).format(normalized);
};
/**
 * Formats a numeric value as currency
 */
export const formatCurrency = (value, currency = "EUR", fractionDigits = 2) => {
    return new Intl.NumberFormat(LOCALE, {
        style: "currency",
        currency,
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
        useGrouping: true,
    }).format(parseFloat(String(value)) || 0);
};
/**
 * Formats a date using the Spanish locale
 */
export const formatDate = (date, options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
}) => {
    const dateObj = typeof date === "string" ? new Date(date) : date;
    return new Intl.DateTimeFormat(LOCALE, options).format(dateObj);
};
export const getMonthName = (month) => {
    const date = new Date(2000, month - 1, 1); // Year 2000 is arbitrary
    return new Intl.DateTimeFormat(LOCALE, { month: "long" }).format(date);
};
